var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemMomentsIconFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#add8e6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.35,10.66,5.8.54a3.74,3.74,0,0,0-3.86,0A3.8,3.8,0,0,0,0,3.88V24.14a3.8,3.8,0,0,0,1.94,3.34A3.85,3.85,0,0,0,3.87,28a4,4,0,0,0,1.94-.52L23.35,17.35a3.86,3.86,0,0,0,0-6.69Zm-8.2,3.95c-3.17.57-4,1.44-4.62,4.61a.56.56,0,0,1-.6.47.57.57,0,0,1-.61-.45c-.58-3.19-1.44-4.06-4.62-4.63A.58.58,0,0,1,4.23,14a.57.57,0,0,1,.46-.6C7.88,12.82,8.74,12,9.32,8.78a.56.56,0,0,1,.61-.46.55.55,0,0,1,.6.45C11.11,12,12,12.82,15.15,13.4a.56.56,0,0,1,.47.6A.57.57,0,0,1,15.15,14.61Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemMomentsIconFill);
export default __webpack_public_path__ + "static/media/item_moments_icon_fill.c5336c503b48c00477c68049836f7b09.svg";
export { ForwardRef as ReactComponent };